import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateTimetableForm from "../../forms/CreateOrUpdateTimetableForm";

interface CreateTimetableJobModalProps {
  open: boolean;
  onClose: () => void;
  userInfo?: any;
  loading: boolean;
  error?: string | null;
}

const CreateTimetableJobModal: React.FC<CreateTimetableJobModalProps> = ({
  open,
  onClose,
  userInfo,
  loading,
  error,
}) => {
  return (
    <AppModal
      open={open}
      onClose={onClose}
      title="Generate Timetable"
      width="sm"
      loading={loading}
    >
      <CreateOrUpdateTimetableForm
        userInfo={userInfo}
        loading={loading}
        error={error}
      />
    </AppModal>
  );
};

export default CreateTimetableJobModal;
